import Typography from '@eduzz/houston-ui/Typography';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { useObservable } from 'react-use-observable';

import { refundsService } from 'v2/services/reports/refunds';

import { ExportRefunds } from './Export';
import { useStyles } from './styles';

export const Details = () => {
  const [totalItems] = useObservable(() => refundsService.getTotalItems(), []);
  const [totalRefunded] = useObservable(() => refundsService.getTotalRefunded(), []);
  const [isLoading] = useObservable(() => refundsService.isLoading(), []);

  const classes = useStyles();

  const refundsCount = `${totalItems} ${totalItems > 1 ? 'reembolsos' : 'reembolso'}`;

  if (isLoading) return null;

  return (
    <Grid id='refunds-details' className={classes.gridContainer} container alignItems='center'>
      <Grid item>
        <ListItem>
          <Typography weight='semibold'>{refundsCount}</Typography>
        </ListItem>
      </Grid>
      <Divider className={classes.divider} orientation='vertical' />
      <Grid item>
        <ListItem>
          <Typography weight='semibold'>
            Total Reembolsado: <ColoredFormattedNumber value={totalRefunded} format='BRL' />
          </Typography>
        </ListItem>
      </Grid>
      <Divider className={classes.divider} orientation='vertical' />
      <PermissionHide action={'myeduzz:reports:exportar'}>
        <Grid item className={classes.exportContainer}>
          <ExportRefunds />
        </Grid>
      </PermissionHide>
    </Grid>
  );
};
